(ns iris.db)

(def default-db
  {:name "Iris CLJS"
   :ws nil
   :ws-sync false
   :jwt nil
   :fp nil
   :bfp nil
   :fb-user nil
   :fb-auth-state nil
   :raids-cache-id nil
   :raidpurger false
   :roles []
   :raid-len 2
   :loading false
   :mobile false
   :viewport-size {:x nil
                   :y nil}
   :scroll-top 0
   :show-moderator-logs false
   :show-search-bar false
   :message nil
   :error nil

   :tracker false

   :messages []
   :message-bar {:mode :latest
                    :index 0
                    :expanded? false}

   :screens {:meta nil
             :data []
             :form-data {:ts (.now js/Date)
                         :actions []
                        ;;  :ban false
                        ;;  :quarantine false
                        ;;  :delay_min 60
                        ;;  :delay_max 120
                        ;;  :hide false
                        ;;  :flag 0
                         :target_level 0
                         :scopes_input ".ALL"
                         :kind "content"
                         :patterns [{:id (.now js/Date)
                                     :kind "word"
                                     :pattern nil
                                     :target_fields ["title" "body" "signed"]
                                     :case_sensitive false
                                     :preserve_case false
                                     :ignore_inserts false
                                     :similar_chars false}]
                         :disable_in nil
                         :disable-in-number nil
                         :disable-in-unit "d"
                         :priority 0
                         :enabled true
                         :notes ""
                         :submitted false}}
   :censors {:meta nil
             :data []
             :form-data {:scopes_input ".ALL"
                         :target_level 0
                         :kind ""
                         :pattern ""
                         :target-title true
                         :target-body true
                         :target-signed true
                         :target_fields ["title" "body" "signed"]
                         :case_sensitive false
                         :preserve_case false
                         :ignore_inserts false
                         :similar_chars false
                         :autosub true
                         :sub ""
                         :disable_in ""
                         :disable-in-number nil
                         :disable-in-unit "d"
                         :notes ""
                         :submitted false
                        ;;  :submit-response ""
                         }
        ;;      :message nil
             }

   :posts {:meta nil
           :data []
        ;;    :ws "TLO"
        ;;    :ws nil
        ;;    :ws-sync false
           :level 0 ;(or 0)
           :sort "submitted"
           :page 1
           :limit 50
           :status "*"
           :flag nil
           :staff nil ;(yes or no)
           :raw nil ;(yes)
           :excerpt nil ;(yes)
           :layout nil ; (table)
           :timer nil
           :font-size 100
           :header nil
           :eid nil}
   :twbot {:data {}}
   :alerts {:data []
            :show-all false}
   :analytics {:report "realtime"
        ;;        :ws "TLO"
               :data nil}
   :tags {:data {(keyword "@OP+1jj758z45") {:ruid "@OP+1jj758z45"
                                            :body "Many people who shouldered a lot of the effort and knew a lot of the things cut in this last round. Paycheck collectors continue to fear. 5's in evals? Eat dirt. Do HR and upper management even understand the damage they are doing to the company? The quality message is laughable when you're keeping so much rotten fruit. Maybe talk to managers instead of having your directors guess to hit a number."
                                            :title "Brain drain"
                                            :excerpt "Many people who shouldered a lot of the effort and knew a lot of the things..."
                                            :tags ["aTag" "aTag2" "aTag3" "aTag4" "aTag5" "aTag6" "aTag7" "aTag8" "aTag9" "aTag10"]
                                            :new-tags ["myTag" "myTag2" "myTag3" "myTag4" "myTag5" "myTag6" "myTag7" "myTag8" "myTag9" "myTag10"]
                                            :order-tags nil
                                            :time-submitted "2025-01-22T14:04:50Z"}
                 (keyword "@OP+1jj6218m1") {:ruid "@OP+1jj6218m1"
                                            :body "Seeing a lot of long-term folks being let go. Are there any protections for workers that require an employer to pay for training a laid off worker in a new field? Canada seems to have something like this, but not sure if USA does."
                                            :title "Worker Retraining"
                                            :excerpt "Seeing a lot of long-term folks being let go. Are there any protections ..."
                                            :tags ["aTag4" "aTag5" "aTag6"]
                                            :new-tags ["myTag4" "myTag5" "myTag6"]
                                            :order-tags nil
                                            :time-submitted "2025-01-22T03:48:56Z"}}
          :modal {:display false}
          :columns {:pending (array-map :select-all {:switchable false :show true :size "fit-content(50px)"}
                                         :ruid {:switchable true :show true :size "fit-content(150px)"}
                                         :body {:switchable true :show true :size "auto"}
                                         :title {:switchable true :show true :size "auto"}
                                         :tags {:switchable true :show true :size "auto"}
                                        ;;  :order {:switchable false :show true :size "fit-content(80px)"}
                                         :time-submitted {:switchable true :show true :size "fit-content(150px)"}
                                         :tags-approved {:switchable true :show true :size "fit-content(50px)"}
                                         :approve {:switchable false :show true :size "fit-content(50px)"}
                                         :reject {:switchable false :show true :size "fit-content(50px)"})}}
   :job-keywords {
                ;;   (keyword ".TLO") [{:data ["ws kw A" "ws kw B" "ws kw C"] :meta {:dt 1696381470}} {:data ["ws kw D" "ws kw E" "ws kw F"] :meta {:dt 1696381471}} {:data ["ws kw G" "ws kw H" "ws kw I"] :meta {:dt 1696381472}}]
                ;;   (keyword "/aaalphabet.TLO") [{:data ["forum kw A" "forum kw B" "forum kw C"] :meta {:dt 1696381485}} {:data ["forum kw D" "forum kw E" "forum kw F"] :meta {:dt 1696381486}} {:data ["forum kw G" "forum kw H" "forum kw I"] :meta {:dt 1696381487}}]
                ;;   (keyword "@OP+1oBepdPc") [ {:data ["thread kw A" "thread kw B" "thread kw C"] :meta {:dt 1696381493}} {:data ["thread kw D" "thread kw E" "thread kw F"] :meta {:dt 1696381494}} {:data ["thread kw G" "thread kw H" "thread kw I"] :meta {:dt 1696381495}}]
                  }

   :logs {:query {:page     1
                  :activity "all"
                  :has-next false}
          :panel nil}}
                  )



;; grk --verbose censor create -w "tester"
;; Calling RPC at URL: http://localhost:8083/rpc
;; JSON payload:
;;  {
;;     "method": "Censor.Create",
;;     "params": {
;;         "data": {
;;             "anySpacing": false,
;;             "caseSensitive": true,
;;             "enabled": false, ???
;;             "kind": "word",
;;             "notes": "",
;;             "overwrite": false, ???
;;             "pattern": "tester",
;;             "preserve_case": false,
;;             "scopesInput": "",
;;             "similarChars": false,
;;             "sub": "",
;;             "targetFields": [
;;                 "title",
;;                 "body",
;;                 "signed"
;;             ]
;;         },
;;         "options": {
;;             "debug": false
;;         }
;;     },
;;     "id": 0,
;;     "jsonrpc": "2.0"
;; }
;; OK. Censoring rule created
;; {
;;     "data": {
;;         "enabled": false,
;;         "id": "Xtester-59e2",
;;         "ignore_case": false,
;;         "iso_created_on": "2021-10-26T01:19:46",
;;         "iso_updated_on": "2021-10-26T01:19:46",
;;         "kind": "word",
;;         "notes": "",
;;         "pattern": "tester",
;;         "priority": 6,
;;         "re_pattern": "\\b(tester)\\b",
;;         "ruid": "Xtester-59e2",
;;         "scopes": [
;;             ".ALL"
;;         ],
;;         "scopes_display": "\u003ca href=\"/censors?scope=.ALL\"\u003e\u003ccode\u003e.ALL\u003c/code\u003e\u003c/a\u003e",
;;         "scopes_expr": ".ALL",
;;         "scopes_input": ".ALL",
;;         "sub": "",
;;         "target_level": 0,
;;         "uid_created_by": "test@example.com",
;;         "uid_updated_by": "test@example.com"
;;     },
;;     "message": "OK. Censoring rule created"
;; }
